import React from "react";
import { Controller } from "react-hook-form";
import { FormControl, InputLabel, MenuItem, Select, Box } from "@material-ui/core";
import { useDockerManagementContext } from "../../DockerManagementProvider";

export default function DeviceModeFormField({ control, errors }) {
	const { state: { availableComposes } } = useDockerManagementContext();
	return (
		<Box display="flex">
			<Box flexGrow={1}>
				<FormControl fullWidth>
					<InputLabel>YAML Selection</InputLabel>
					<Controller
						name="yamlFile"
						control={control}
						render={({ field }) => (
							<Select
								{...field}
								defaultValue=""
								placeholder="Select a YAML file..."
								fullWidth
								error={!!errors.yamlFile}>
								{availableComposes.map(s => {
									return <MenuItem key={s} value={s}>{s}</MenuItem>
								})}
							</Select>
						)}
					/>
				</FormControl>
			</Box>
		</Box>
	);
}